var _templateObject, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.884 1.646a21 21 0 0 0-1.965-.035c-1.163.036-1.75 1.338-1.122 2.252 1.8 2.624 3.295 4.742 4.787 6.745l-5.322 5.914a1.042 1.042 0 0 0 1.548 1.394L8.865 12.3a162 162 0 0 0 4.217 5.232 2.23 2.23 0 0 0 1.51.797 14.5 14.5 0 0 0 2.073.049c1.155-.056 1.696-1.35 1.087-2.241-2.102-3.076-3.781-5.466-5.438-7.67l4.53-5.033a1.042 1.042 0 1 0-1.55-1.393l-4.269 4.744A122 122 0 0 0 7.45 2.43a2.25 2.25 0 0 0-1.566-.784",
    clipRule: "evenodd"
  }))));
};
export default SvgTwitter;